import { DropzoneFile } from 'components/Dropzone/utils';
import { ObjectValues } from 'types';
import { User } from './User';
import { Listing } from './Listing';
import { DealRoom } from './DealRoom';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { LeadNdaProps, SoftSignal } from './Lead';
import { EnquiryQuestionType } from 'router/subrouters/Dash/subrouters/Business/components/EnquirySlider/utils';
import { UploadedFile } from './File';
import { ReactionType } from './Reactions';

export const MESSAGE_STATUS_INDICATOR = {
  ERROR: 'ERROR',
  NOT_SENT: 'NOT_SENT',
} as const;

type MessageStatusIndicator = ObjectValues<typeof MESSAGE_STATUS_INDICATOR>;

export type DocumentFile = { fileName: string; file: DropzoneFile };

export type MessageType = {
  _id: string;
  text: string;
  userId: string;
  sessionId: string;
  session: SessionType;
  createdAt?: string;
  updatedAt?: string;
  statusIndicator: MessageStatusIndicator;
  showDate?: string;
  files: MessageFileType[];
  isInterestContext?: boolean;
  softSignal?: SoftSignal;
  dataRoomNodeId?: string;
  dataRoomNode?: DataRoomNode;
  dataRoomNodeName?: string;
  seenAt?: Date;
  isPulseCheck?: boolean;
  isDeleted?: boolean;
  reaction: ReactionType;
};

type KeyMessagingType = {
  interlocutor: User;
  isBuyer: boolean;
  buyerId: string;
  listing: Listing & { dealRoom: DealRoom };
};

export type SessionType = {
  id: string;
  latestMessageAt: Date;
  hasUnreadMessages: boolean;
  leadId: string;

  enquiryQuestions: EnquiryQuestionType[];
  dataRoomNodes: DataRoomNode[];
  leadWithdrawnInterest?: boolean;
  isExternalCommunication?: boolean;
  isClosed?: boolean;
  dealRoomOwnerName?: string;
  manuallySetNDAStatus?: boolean;
} & KeyMessagingType &
  LeadNdaProps;

export type UserConnection = {
  _id: string;
  session: SessionType;
} & KeyMessagingType;

export type MessageFileType = DropzoneFile & {
  chatSessionFileId?: string;
};

export type ChatSessionFile = UploadedFile & {
  sessionId: string;
};
